// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import ScrollToTop from './utils/scrollToTop';
// import './styles/App.scss';
// import Header from './components/Header';
// import Footer from './components/Footer';
// import Hero from './components/Hero';
// import GoldRates from './components/GoldRates';
// import Calculator from './components/Calculator';
// import Services from './components/Services';
// import WhyUsPage from './components/WhyUsPage';
// import About from './components/About';
// import Contact from './components/Contact';
// import FAQPages from './components/FAQPages';

// function App() {
//   return (
//     <Router>
//       <ScrollToTop /> {/* Add this */}
//       <div className="App">
//         <Header />
//         <main>
//           <Routes>
//             <Route path="/" element={
//               <>
//                 <Hero />
//                 <GoldRates />
//                 <Calculator />
//                 <Services />
//               </>
//             } />
//             <Route path="/about" element={<About />} />
//             <Route path="/contact" element={<Contact />} />
//             <Route path="/why-us" element={<WhyUsPage />} />
//             <Route path="/faq/:type" element={<FAQPages />} />
//             <Route path="/faq" element={<FAQPages />} />
//           </Routes>
//         </main>
//         <Footer />
//       </div>
//     </Router>
//   );
// }

// export default App;

// App.js
import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="construction-container">
        <h1 className="glitch-text">🚧 UNDER CONSTRUCTION 🚧</h1>
        <div className="content">
          <h2>Something Amazing is Coming</h2>
          <div className="loader"></div>
          <p className="meeting-text">We'll meet you soon!</p>
          <div className="progress-bar">
            <div className="progress"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;